module.exports = __webpack_public_path__ + "img/MFT白皮书_32.7ffb9863.jpg";